export function NewPillMark() {
  return (
    <span className="inline-flex h-5 shrink-0 items-center rounded-full border border-blue-100 bg-blue-50 px-2.5 font-inter text-xs font-medium leading-none text-blue-700">
      New
    </span>
  );
}
